import { useState } from "react";
import { Lock, Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";
import { T } from "@/lib/i18n";

export const PasswordInput = ({ testid, ...props }) => {
  const [show, setShow] = useState(false);
  const Icon = show ? EyeOff : Eye;
  return (
    <div className="relative">
      <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#71717a]" />
      <Input data-testid={testid} type={show ? "text" : "password"} {...props}
        className="pl-10 pr-11 h-12 bg-[#18181b] border-[#27272a] text-white placeholder:text-[#52525b] rounded-sm font-mono text-sm" required />
      <button type="button" data-testid={`${testid}-toggle`} onClick={() => setShow((v) => !v)}
        aria-label={show ? T("Nascondi password", "Hide password") : T("Mostra password", "Show password")} aria-pressed={show}
        className="absolute right-1 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center text-[#a1a1aa] hover:text-white transition-colors">
        <Icon className="w-4 h-4" />
      </button>
    </div>
  );
};
